export interface CharCounterProps {
  /** Current character count. */
  current: number;
  /** Maximum allowed characters. */
  max: number;
}

/**
 * Live `current/max` character counter for text inputs. Turns destructive
 * when the value exceeds the limit so it pairs with an inline Zod `.max()`
 * error. Does not enforce the limit itself (soft limit by design).
 */
export function CharCounter({ current, max }: CharCounterProps) {
  const isOver = current > max;
  return (
    <p
      className={`text-xs ${isOver ? 'text-destructive' : 'text-muted-foreground'}`}
      aria-live="polite"
    >
      {current}/{max}
    </p>
  );
}

CharCounter.displayName = 'CharCounter';
